module.exports = __webpack_public_path__ + "static/media/icon_6.2e3dbd25.svg";